import { render, staticRenderFns } from "./ExpirationCheck.vue?vue&type=template&id=3ebb566e&"
import script from "./ExpirationCheck.vue?vue&type=script&lang=js&"
export * from "./ExpirationCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports